import parseDom from 'dom-parse';
import { createElement } from 'react';
import getDisplayName from 'react-display-name';
import cssToStyle from 'css-to-style';

// See https://dom.spec.whatwg.org/#dom-node-nodetype
var ELEMENT_NODE = 1;
var TEXT_NODE = 3;

var reactProps = ['children', 'dangerouslySetInnerHTML', 'key', 'ref', 'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', // deprecated
'valueLink'];

var htmlProps = [// HTML Standard
'accept', 'acceptCharset', 'accessKey', 'action', 'allowFullScreen', 'allowTransparency', 'alt', 'async', 'autoComplete', 'autoFocus', 'autoPlay', 'capture', 'cellPadding', 'cellSpacing', 'challenge', 'charSet', 'checked', 'cite', 'classID', 'className', 'colSpan', 'cols', 'content', 'contentEditable', 'contextMenu', 'controls', 'coords', 'crossOrigin', 'data', 'dateTime', 'default', 'defer', 'dir', 'disabled', 'download', 'draggable', 'encType', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate', 'formTarget', 'frameBorder', 'headers', 'height', 'hidden', 'high', 'href', 'hrefLang', 'htmlFor', 'httpEquiv', 'icon', 'id', 'inputMode', 'integrity', 'is', 'keyParams', 'keyType', 'kind', 'label', 'lang', 'list', 'loop', 'low', 'manifest', 'marginHeight', 'marginWidth', 'max', 'maxLength', 'media', 'mediaGroup', 'method', 'min', 'minLength', 'multiple', 'muted', 'name', 'noValidate', 'nonce', 'open', 'optimum', 'pattern', 'placeholder', 'poster', 'preload', 'profile', 'radioGroup', 'readOnly', 'rel', 'required', 'reversed', 'role', 'rowSpan', 'rows', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'spellCheck', 'src', 'srcDoc', 'srcLang', 'srcSet', 'start', 'step', 'style', 'summary', 'tabIndex', 'target', 'title', 'type', 'useMap', 'value', 'width', 'wmode', 'wrap', // HTML RDFa
'about', 'datatype', 'inlist', 'prefix', 'property', 'resource', 'typeof', 'vocab', // HTML Non-Standard
'autoCapitalize', 'autoCorrect', 'color', 'itemProp', 'itemScope', 'itemType', 'itemRef', 'itemID', 'security', 'unselectable', 'results', 'autoSave'];

var svgProps = ['accentHeight', 'accumulate', 'additive', 'alignmentBaseline', 'allowReorder', 'alphabetic', 'amplitude', 'arabicForm', 'ascent', 'attributeName', 'attributeType', 'autoReverse', 'azimuth', 'baseFrequency', 'baseProfile', 'baselineShift', 'bbox', 'begin', 'bias', 'by', 'calcMode', 'capHeight', 'clip', 'clipPath', 'clipPathUnits', 'clipRule', 'colorInterpolation', 'colorInterpolationFilters', 'colorProfile', 'colorRendering', 'contentScriptType', 'contentStyleType', 'cursor', 'cx', 'cy', 'd', 'decelerate', 'descent', 'diffuseConstant', 'direction', 'display', 'divisor', 'dominantBaseline', 'dur', 'dx', 'dy', 'edgeMode', 'elevation', 'enableBackground', 'end', 'exponent', 'externalResourcesRequired', 'fill', 'fillOpacity', 'fillRule', 'filter', 'filterRes', 'filterUnits', 'floodColor', 'floodOpacity', 'focusable', 'fontFamily', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle', 'fontVariant', 'fontWeight', 'format', 'from', 'fx', 'fy', 'g1', 'g2', 'glyphName', 'glyphOrientationHorizontal', 'glyphOrientationVertical', 'glyphRef', 'gradientTransform', 'gradientUnits', 'hanging', 'horizAdvX', 'horizOriginX', 'ideographic', 'imageRendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kernelMatrix', 'kernelUnitLength', 'kerning', 'keyPoints', 'keySplines', 'keyTimes', 'lengthAdjust', 'letterSpacing', 'lightingColor', 'limitingConeAngle', 'local', 'markerEnd', 'markerHeight', 'markerMid', 'markerStart', 'markerUnits', 'markerWidth', 'mask', 'maskContentUnits', 'maskUnits', 'mathematical', 'mode', 'numOctaves', 'offset', 'opacity', 'operator', 'order', 'orient', 'orientation', 'origin', 'overflow', 'overlinePosition', 'overlineThickness', 'paintOrder', 'panose1', 'pathLength', 'patternContentUnits', 'patternTransform', 'patternUnits', 'pointerEvents', 'points', 'pointsAtX', 'pointsAtY', 'pointsAtZ', 'preserveAlpha', 'preserveAspectRatio', 'primitiveUnits', 'r', 'radius', 'refX', 'refY', 'renderingIntent', 'repeatCount', 'repeatDur', 'requiredExtensions', 'requiredFeatures', 'restart', 'result', 'rotate', 'rx', 'ry', 'scale', 'seed', 'shapeRendering', 'slope', 'spacing', 'specularConstant', 'specularExponent', 'speed', 'spreadMethod', 'startOffset', 'stdDeviation', 'stemh', 'stemv', 'stitchTiles', 'stopColor', 'stopOpacity', 'strikethroughPosition', 'strikethroughThickness', 'string', 'stroke', 'strokeDasharray', 'strokeDashoffset', 'strokeLinecap', 'strokeLinejoin', 'strokeMiterlimit', 'strokeOpacity', 'strokeWidth', 'surfaceScale', 'systemLanguage', 'tableValues', 'targetX', 'targetY', 'textAnchor', 'textDecoration', 'textLength', 'textRendering', 'to', 'transform', 'u1', 'u2', 'underlinePosition', 'underlineThickness', 'unicode', 'unicodeBidi', 'unicodeRange', 'unitsPerEm', 'vAlphabetic', 'vHanging', 'vIdeographic', 'vMathematical', 'values', 'vectorEffect', 'version', 'vertAdvY', 'vertOriginX', 'vertOriginY', 'viewBox', 'viewTarget', 'visibility', 'widths', 'wordSpacing', 'writingMode', 'x', 'x1', 'x2', 'xChannelSelector', 'xHeight', 'xlinkActuate', 'xlinkArcrole', 'xlinkHref', 'xlinkRole', 'xlinkShow', 'xlinkTitle', 'xlinkType', 'xmlns', 'xmlnsXlink', 'xmlBase', 'xmlLang', 'xmlSpace', 'y', 'y1', 'y2', 'yChannelSelector', 'z', 'zoomAndPan'];

var propsLookup = [].concat(htmlProps, svgProps).reduce(function (acc, value) {
  acc[value.toLowerCase()] = value;
  return acc;
}, {});

var attrToPropName = function attrToPropName(attrName) {
  var lowerAttrName = attrName.toLowerCase().replace(/[^a-z0-9]/g, ''); // Handle special exceptions.

  if (lowerAttrName === 'class') {
    return 'className';
  }

  if (lowerAttrName === 'for') {
    return 'htmlFor';
  }

  return propsLookup[lowerAttrName];
};

// Checks if an object has an own property with the specified name.
var has = function has(obj, name) {
  return Object.prototype.hasOwnProperty.call(obj, name);
}; // Checks if an array contains a value.

var includes = function includes(arr, search) {
  return Array.prototype.indexOf.call(arr, search) !== -1;
}; // Checks if the input value is null or undefined.

var isNil = function isNil(value) {
  return value == null;
}; // Checks if a string starts with the characters of a specified string.

var startsWith = function startsWith(string, search) {
  return String.prototype.indexOf.call(string, search) === 0;
};

var attrsToProps = function attrsToProps(attrs) {
  var props = {};

  for (var i = 0; i < attrs.length; i++) {
    var _attrs$i = attrs[i],
        name = _attrs$i.name,
        value = _attrs$i.value; // Disallow event attributes and react props.

    if (startsWith(name, 'on') || includes(reactProps, name)) {
      continue;
    } // Don't modify aria-* or data-* attributes.


    if (startsWith(name, 'aria-') || startsWith(name, 'data-')) {
      props[name] = value;
      continue;
    } // Handle style attribute.


    if (name === 'style') {
      props[name] = cssToStyle(value);
      continue;
    }

    props[attrToPropName(name) || name] = value === '' ? true : value;
  }

  return props;
};

var nodesToElements = function nodesToElements(nodeList, options) {
  var tree = [];

  for (var i = 0; i < nodeList.length; i++) {
    var node = nodeList[i]; // Handle text nodes.

    if (node.nodeType === TEXT_NODE) {
      // Handle trim option to remove whitespace text nodes.
      if (options.trim !== true || node.textContent.trim() !== '') {
        tree.push(node.textContent);
      }

      continue;
    } // Only render element (and text) nodes.


    if (node.nodeType !== ELEMENT_NODE || // Never render <script> elements.
    node.nodeName.toLowerCase() === 'script' || // Handle allowed option to only render elements that are allowed.
    !isNil(options.allowed) && !includes(options.allowed, node.nodeName.toLowerCase())) {
      continue;
    }

    var type = node.nodeName.toLowerCase(); // Handle replace option.

    if (!isNil(options.replace) && has(options.replace, type)) {
      type = options.replace[type]; // Don't render falsey replacements.

      if (!type) {
        continue;
      }
    }

    var props = attrsToProps(node.attributes);
    props.key = getDisplayName(type) + "-" + i;
    tree.push(createElement(type, props, nodesToElements(node.childNodes, options)));
  }

  return tree.length > 0 ? tree : null;
};

var renderMarkup = function renderMarkup(markup, options) {
  if (options === void 0) {
    options = {};
  }

  if (process.env.NODE_ENV !== 'production') {
    if (typeof markup !== 'string' && !isNil(markup)) {
      throw new TypeError('Expected parameter "markup" to be a string.');
    }

    if (typeof options !== 'object') {
      throw new TypeError('Expected parameter "options" to be an object.');
    }
  }

  return isNil(markup) ? null : nodesToElements(parseDom(markup), options);
};

export default renderMarkup;
